/**
 * Created by sswaminathan on 1/8/22
 * File: LicenseProductHeader
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Textarea } from '@panwds/react-form-legacy'
import { Body, Bold } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import Page from '../../../common/components/page/Page'
import {
  APP_ID_LOGGING_SERVICE,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_SDWAN
} from '../../../common/constants/GlobalConstants'
import RegionDropDown from '../../../common/region/RegionDropDown'
import { getVarValue } from '../../../common/utils/Sparky'
import {
  CONTRACT_LABEL,
  REGION_CAPS_LABEL,
  SELECT_REGION_DESC,
  SELECT_REGION_LABEL, SUBSCRIPTION_ACTION_EDIT,
} from '../constants/SubscriptionConstant'
import { DATA_CONTRACT_DROPDOWN, DATA_REGION_DROPDOWN } from '../constants/TestingDataIds'
import DropDown from '../dropdown/DropDown'
import ProductRegions from './ProductRegions'

const LicenseProductHeader = (props) => {

  const {
    selectedTreeNode,
    licenseValue,
    licenseDetails,
    handleOnChange,
    appList,
    supportedRegions,
    licenseInfo,
    licenseAction,
    editDisabled,
    cgxProduct,
    support_account_id } = props
  const showDescription = getVarValue('show_description', false)
  const [regionList, setRegionList] = useState([])
  const { setValue } = useFormContext()
  const [disableRegion, setDisableRegion] = useState(false)
  const [disableContract, setDisableContract] = useState(false)
  const [optional, setOptional] = useState(false)
  const [appRegions, setAppRegions] = useState({})
  //Disable contract and region for EDIT operation
  const _app_ids = Object.keys(licenseInfo)
  const isRegionAvailable = _app_ids?.find(each => licenseInfo[each].region !== 'global')
  useEffect(() => {
    setDisableRegion(() => {
      return licenseAction === SUBSCRIPTION_ACTION_EDIT && isRegionAvailable
    })
    // For single tenant  if extra.license_id is not present , pick from the tenant_id
    setDisableContract(() => {
      return !!(licenseAction === SUBSCRIPTION_ACTION_EDIT && (licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.extra?.license_id ||
        licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.tenant_id))
    })
  }, [licenseInfo, licenseAction, isRegionAvailable])

  useEffect(() => {
    if (licenseAction !== SUBSCRIPTION_ACTION_EDIT) {
      setOptional(!cgxProduct.length)
    }
    else if (licenseAction === SUBSCRIPTION_ACTION_EDIT) {
      if (licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.extra?.license_id ||
        licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.tenant_id || cgxProduct.length) {
        setOptional(false)
      }
    }
  }, [cgxProduct.length, licenseAction, licenseInfo])

  useEffect(() => {
    if (licenseValue === '' && licenseAction !== SUBSCRIPTION_ACTION_EDIT) {
      const appListForAdd = []
      if (cgxProduct.length > 0) {
        appListForAdd.push(APP_ID_SDWAN)
      }
      setAppRegions({})
      setRegionList(RegionDropDown(appListForAdd, cgxProduct.length > 0 ? supportedRegions : [], true, support_account_id))
    }
    else {
      const regionDropDown = RegionDropDown(appList, supportedRegions, true, support_account_id)
      setRegionList(regionDropDown)
      const apps = Object.keys(editDisabled)
      const regionKey = apps.find((each) => {
        return editDisabled[each] && (licenseInfo[each]?.region && licenseInfo[each]?.region !== 'global')
      })
      const licenseInfoRegion = licenseInfo[regionKey]?.platform_region ??
        licenseInfo[APP_ID_LOGGING_SERVICE]?.region ?? licenseInfo[APP_ID_SDWAN]?.region ?? licenseInfo[isRegionAvailable]?.region
      const userSelectedRegion = regionDropDown.find((each) => each.id === licenseInfoRegion)
      if (userSelectedRegion) {
        setValue('region_name', userSelectedRegion)
        if (userSelectedRegion?.additional_region_mapping) {
          setAppRegions(userSelectedRegion.additional_region_mapping)
        }
      }
      else {
        setValue('region_name', regionDropDown[0])
      }

    }
  }, [licenseAction, appList, supportedRegions, licenseValue, setValue, licenseInfo, cgxProduct, editDisabled, support_account_id, isRegionAvailable])

  useEffect(() => {
    if (licenseAction !== SUBSCRIPTION_ACTION_EDIT) {
      setAppRegions({})
      setValue('region_name', regionList[0])
    }
    else {
      let licenseId
      if (licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.extra?.license_id) {
        licenseId = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.extra?.license_id
      }
      else if (licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.tenant_id) {
        licenseId = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.tenant_id
      }
      else {
        licenseId = licenseValue
      }
      const contract_value = licenseDetails.find((elem) => elem?.id?.length && licenseId.indexOf(elem.id) >= 0)
      setValue('contract_id', contract_value)
    }
  }, [licenseValue, licenseAction, licenseInfo, licenseDetails, regionList, setValue])


  const onRegionChange = useCallback((change) => {
    if (change?.target?.value?.additional_region_mapping) {
      setAppRegions(change?.target?.value?.additional_region_mapping)
    }
    else {
      setAppRegions({})
    }
  }, [])

  return (<div className='tw-ml-4'>
    <Page pageHeaderProps={{
      style: { marginBottom: 20 },
      size: 'xs',
      title: <Bold>{selectedTreeNode?.display_name}</Bold>,
      level: 2,
      subTitle: selectedTreeNode?.vertical || ''
    }}>
      <div className='tw-flex tw-flex-row'>
        <div className='tw-flex-1'>
          <DropDown
            addClassName='cmm-modal-select'
            fieldName='contract_id'
            itemList={licenseDetails}
            label={CONTRACT_LABEL}
            changeHandler={handleOnChange}
            dataTestId={DATA_CONTRACT_DROPDOWN}
            width='400px'
            disable={disableContract}
            required={optional}
            height='40px'
          />
        </div>
        {showDescription && <div className='tw-flex-1 tw-pt-5 tw-pr-10'>
          <Textarea
            name='description'
            label='description'
            showLabel="false"
            rowsMin="2"
            rowsMax="5"
            placeholder='Placeholder...'
            optional='true'
            disabled={false}
            register={{
              required: false
            }}
          />
        </div>}
      </div>
      <Body size="sm" appearance="primary" addClassName='tw-py-4 tw-pl-1'>
        <Bold appearance="semibold">{SELECT_REGION_LABEL}</Bold>
      </Body>
      <DropDown
        addClassName='cmm-modal-select'
        itemList={regionList}
        desc={SELECT_REGION_DESC}
        fieldName='region_name'
        disable={disableRegion}
        errorLabel={SELECT_REGION_LABEL}
        dataTestId={DATA_REGION_DROPDOWN}
        label={REGION_CAPS_LABEL}
        changeHandler={onRegionChange}
        required={true}
        width='400px'
        height='40px'/>
      {(Object.keys(appRegions)?.length) ? Object.keys(appRegions).map((each, index) => {
        return <ProductRegions
          key={index}
          {...{
            appRegion: appRegions[each],
            appName: each,
            licenseValue,
            width: '400px',
            height: '40px',
            licenseInfo
          }}/>
      }) : <></>}
    </Page>
  </div>)
}

LicenseProductHeader.propTypes = {}
export default LicenseProductHeader
